import { BudgetSettings } from "../components/settings/BudgetSettings";

export default function BudgetSettingsPage() {
    return <div className="flex flex-col gap-4">
        <BudgetSettings />
    </div>
}